import { QuestStatus } from 'src/enums/quests';

export const QUESTS_INITIAL_ROWS_PER_PAGE = 10;

export const CURRENT_WORK_QUEST_STATUS = [
    QuestStatus.PLANNING,
    QuestStatus.NEW,
    QuestStatus.IN_PROCESS,
    QuestStatus.IN_REVIEW
];
